"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";

/**
 * Listing page - hidden for now.
 * Redirects to homepage.
 */
export default function ListingPage() {
  const router = useRouter();

  useEffect(() => {
    router.replace("/");
  }, [router]);

  return null;
}
